export default "__VITE_ASSET__DpliT6LE__"